import React from 'react';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import Editor from '../components/Editor';
import { ScopeComponentList } from '../components/ScopeComponent';
import { ProjectContext } from './context';
export function Services() {
  const [css] = useStyletron();
  const projectCtx = React.useContext(ProjectContext);
  return <div className={css({
    padding: '1em'
  })}>
      <HeadingLevel>
        <Heading>Instructions</Heading>
      </HeadingLevel>
      <div className={css({
      margin: '1em 0'
    })} data-testid="instructions-html-editor">
        <Editor onChange={instructionsHtml => projectCtx.edit({
        instructions_html: instructionsHtml
      })} value={projectCtx.instructionsHtml()} />
      </div>
      <ScopeComponentList />
    </div>;
}